export type XyStatusCode = '0' | '3' | '4' | '5' | '6' | '10' | '99';
